export const ParagraphType = 'PARAGRAPH';
